/* unplugin-vue-components disabled */import { render } from "./TextAnalogyQuestion.vue?vue&type=template&id=37dd6f67&scoped=true"
import script from "./TextAnalogyQuestion.vue?vue&type=script&lang=js"
export * from "./TextAnalogyQuestion.vue?vue&type=script&lang=js"

import "./TextAnalogyQuestion.vue?vue&type=style&index=0&id=37dd6f67&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dd6f67"]])

export default __exports__